<template>
  <section :style="'background-image: url(' + items.image.url + ')'" v-bsl="zoomActive">
    <img :src="items.image.url" :alt="items.image.alt || ' '">
    <div class="cursor" ref="cursor"></div>
  </section>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
export default {
  props: ['items', 'pagePosition', 'siblings-components'],
  name: 'product_zoom',
  mixins: [ReadyHook],
  data () {
    return {
      zoomActive: false
    }
  },
  mounted () {
    this.$el.addEventListener('mouseout', () => {
      this.$refs.cursor.style.position = 'absolute'
      this.$refs.cursor.style.left = '50%'
      this.$refs.cursor.style.top = '50%'
    })
    this.$el.addEventListener('mousemove', (e) => {
      if (this.zoomActive) {
        let dimensions = this.$el.getBoundingClientRect()

        this.relX = e.clientX - dimensions.left
        this.relY = e.clientY - dimensions.top

        this.percentX = Math.round(100 / (dimensions.width / this.relX))
        this.percentY = Math.round(100 / (dimensions.height / this.relY))

        this.$el.style.backgroundPosition = this.percentX + '% ' + this.percentY + '%'
      }
      this.$refs.cursor.style.position = 'fixed'
      this.$refs.cursor.style.left = e.clientX + 'px'
      this.$refs.cursor.style.top = e.clientY + 'px'
    }, false)

    this.$el.addEventListener('click', () => {
      if (this.zoomActive) {
        this.zoomActive = false
        this.$el.classList.remove('expanded')
        this.$el.style.backgroundPosition = 'center'
        this.$el.style.backgroundSize = '100%'
      } else {
        this.zoomActive = true
        this.$el.classList.add('expanded')
        this.$el.style.backgroundSize = '200%'

        window.scrollTo({
          top: this.$el.offsetTop,
          behavior: 'smooth'
        })
      }
    })
  }
}
</script>

<style lang="scss" scoped>
@import "~theme/css/core";

section {
  position: relative;
  overflow: hidden;
  height: calc(100vw / 2.13);
  background-size: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-color: #000;
  cursor: none;
  transition: all .4s linear;
  max-height: 60vh;

  &:hover {
    .cursor {
      opacity: 1;
    }
  }

  img {
    display: none;
  }

  .cursor {
    opacity: 0;
    position: absolute;
    z-index: 2000;
    width: 8rem;
    height: 8rem;
    border-radius: 100%;
    pointer-events: none;
    border: 1px solid white;
    transform: translate(-50%, -50%);
    transition: height 0.2s ease-in-out, width 0.2s ease-in-out;

    @include bp(max md) {
      position: absolute !important;
      top: 50% !important;
      left: 50% !important;
      opacity: 1;
      width: 4rem;
      height: 4rem;
      transition: opacity 0.2s ease-in-out;
      &:before {
        height: 1rem;
      }
      &:after {
        width: 1rem;
      }
    }

    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      height: 2rem;
      width: .1rem;
      background: #ffffff;
      transform: translate(-50%, -50%);
      transition: all 0.2s ease-in-out;
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      height: .1rem;
      width: 2rem;
      background: #ffffff;
      transform: translate(-50%, -50%);
      transition: all 0.2s ease-in-out;
    }
  }

  &.expanded {
    height: calc(100vh - 12rem);
    max-height: 100vh;

    .cursor {
      width: 4rem;
      height: 4rem;
      @include bp(max md) {
        opacity: 0;
      }
      &:after {
        width: 1rem;
      }
      &:before {
        opacity: 0;
        height: 1rem;
      }
    }
  }

  @include bp(max md) {
    height: 40vh;
    background: none;
    transition: all .4s ease-in-out;

    img {
      display: block;
      position: relative;
      max-width: none;
      width: 100%;
      transition: all .4s ease-in-out;
    }

    &.expanded {
      overflow: scroll;
      height: calc(100vh - 9rem);

      img {
        width: 300vw;
      }
    }
  }
}

</style>
